import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { UserProfile } from 'types/api'
import { BaseParams } from 'types/utils'

export function useUploadPhoto() {
  const toast = useToast()
  const queryClient = useQueryClient()
  const onError = useOnError() // Added useOnError
  const { t } = useTranslation('users') // Added translation hook

  async function uploadPhoto({ body }: BaseParams<FormData, 'POST'>) {
    const { data } = await apiClient.post<UserProfile>(
      `${SNA_PREFIX}users/me/photo`,
      body,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )

    return data
  }

  return useMutation({
    mutationFn: uploadPhoto,
    onSuccess: () => {
      toast.success({ message: t('toast.profilePhotoUploaded') })
      queryClient.invalidateQueries({ queryKey: ['profile-photo'] })
    },
    onError // Updated to use useOnError
  })
}
